import { Lock } from "lucide-react";

/** Reusable green "rate locked" reassurance chip.
 *  GLPFlo promise: monthly / subscribe / royal price never changes as the
 *  patient's dose goes up. Shown on the public /pricing page and on every
 *  patient-facing checkout surface. */
export default function RateLockBadge({ className = "", testid = "rate-lock-badge" }) {
  return (
    <div className={`flex justify-center ${className}`} data-testid={testid}>
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-900/60 text-xs sm:text-sm font-semibold text-emerald-700 dark:text-emerald-300">
        <Lock className="w-4 h-4" />
        Price never rises with your dose — locked at every strength.
      </div>
    </div>
  );
}
